/*
 *  Switch.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import React, { useMemo } from "react";
import styled, { withTheme } from "styled-components";
//------------------------------------------------------------------------------
// Internal dep.
//------------------------------------------------------------------------------
import logger from "../../../../utils/LoggerFrontend";
//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------
const ActiveBackground = styled.div`
  height: 32px;
  border-radius: 6px;
  background-color: ${(props) => props?.theme?.colors?.bg__selected || "#ffffff"};
  box-shadow: 0px 1px 2px 0px #1e1f461f;
  transition: all 0.2s;
  position: absolute;
  top: 3px;
  ${(props) =>
    props.left
      ? `
    left: 3px;
    transform: translate(0, 0);
  `
      : `
    left: -3px;
    transform: translate(100%, 0);
  `}
`;
const Option = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  border-radius: 6px;
  transition: all 0.2s;
  font-family: Rubik;
  font-size: 12px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  color: ${(props) =>
    props.active
      ? props?.theme?.colors?.bg__selected
        ? "#FFFFFF"
        : "#1E22FF"
      : props?.theme?.colors?.bg__selected || "#000000"};
`;
const SwitchWrapper = styled.div`
  display: flex;
  height: 38px;
  width: ${(props) => (props.width === 1 ? "100%" : `${props.width}px`)};
  border-radius: 8px;
  background-color: #eeeef1;
  cursor: pointer;
  user-select: none;
  position: relative;
  padding: 3px;
  ${Option}, ${ActiveBackground} {
    width: ${(props) => (props.width === 1 ? "50%" : `${props.width / 2}px`)};
  }
`;
const ModeIcon = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;
//------------------------------------------------------------------------------
// Main Functional Component
//------------------------------------------------------------------------------
const Switch = ({ isLeft, switchAction, leftOption, rightOption, width = 242, theme }) => {
  logger.debug("Switch:render", "render:", {
    isLeft,
    leftOption,
    rightOption,
    theme
  });

  const leftOptionColorProps = useMemo(
    () => ({
      [leftOption.isStroke ? "stroke" : "fill"]: isLeft
        ? theme?.colors?.bg__selected
          ? "#FFFFFF"
          : "#1E22FF"
        : theme?.colors?.bg__selected || "#000000"
    }),
    [isLeft, leftOption.isStroke, theme]
  );

  const rightOptionColorProps = useMemo(
    () => ({
      [rightOption.isStroke ? "stroke" : "fill"]: !isLeft
        ? theme?.colors?.bg__selected
          ? "#FFFFFF"
          : "#1E22FF"
        : theme?.colors?.bg__selected || "#000000"
    }),
    [isLeft, rightOption.isStroke, theme]
  );

  return (
    <SwitchWrapper onClick={switchAction} width={width}>
      <ActiveBackground left={isLeft} />
      <Option active={isLeft}>
        {leftOption.Icon && (
          <ModeIcon>
            <leftOption.Icon {...leftOptionColorProps} />
          </ModeIcon>
        )}
        {leftOption.label}
      </Option>
      <Option active={!isLeft}>
        {rightOption.Icon && (
          <ModeIcon>
            <rightOption.Icon {...rightOptionColorProps} />
          </ModeIcon>
        )}
        {rightOption.label}
      </Option>
    </SwitchWrapper>
  );
};

export default withTheme(Switch);
